import { Injectable } from '@angular/core';
import { IFilterListService } from './ifilter-list.service';
import { map } from 'rxjs';
import { Selectable } from '../models/types/selectable.type';
import { GetQuery } from '../../models/shared/enums/get-query.enum';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WrapperResultGraphQL } from '../../models/shared/types/wrapper-result-graphql.type';
import { PageInfo } from '../../models/shared/types/page-info.type';
import { Brand } from '../../models/common/brand.model';
import { PhotographerStatus } from '../../models/common/photographer-status.model';

@Injectable({
  providedIn: 'root'
})
export class PhotographerStatusFilterService extends IFilterListService<PhotographerStatus> {
  pageInfo: PageInfo = { hasPreviusPage: false, hasNextPage: false, startCursor: null, endCursor: null };

  search(searchText: string, variables, isFirst: boolean): void {
    if (searchText || isFirst) this.pageInfo = { ...this.pageInfo, endCursor: null, startCursor: null };

    this.graphQlService.getData<PhotographerStatus>(GetQuery.GET_PHOTOGRAPHER_STATUS_NO_IDS)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(res => res['data']['photographerStatus'])
      )
      .subscribe({
        next: (res: WrapperResultGraphQL<PhotographerStatus>) => {
          let datasource: Array<Selectable<PhotographerStatus>> = [];
          datasource = res.nodes.map(el => ({ ...el, disabled: false, selected: false, displayId: el.id, displayName: el.name }));

          this.datasource.next(datasource);
        }
      })
  }
}
